
import React, { PureComponent } from 'react'

import { connect } from 'react-redux'

import DealerSummary from './DealerSummary'
import TimeSummary from './TimeSummary'
import CarSummary from './CarSummary'

import './SummaryBlock.css'
const mapStateToProps = state => state

class SummaryBlock extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isExistPrestationWithForfait: false
    }
    this.isExistPrestationWithForfait = this.isExistPrestationWithForfait.bind(this)
  }

  isExistPrestationWithForfait() {
    let price = 0
    this.props.store.SelectedServices.forEach((fforfait, ffkey) => {
      fforfait.forfaits != null && !!Object.values(fforfait.forfaits) &&
        Object.values(fforfait.forfaits).forEach((forfait, fkey) => {
          !!Object.values(forfait.SubFunctionList).length &&
            forfait.SubFunctionList[0].ForfaitList.forEach((forfaitItem, fikey) => {
              if (forfaitItem.isSelected) {
                price += forfaitItem.Items[0].Prix
              }
              forfaitItem.Operations && forfaitItem.Operations.forEach((operation, OpKey) => {
                if (operation.isSelected) {
                  price += operation.Items[0].Prix
                }
              })
            })

        })
    })
    return (price > 0)
  }

  componentDidUpdate(prevProps, prevState) {
    this.setState({ isExistPrestationWithForfait: this.isExistPrestationWithForfait() })
  }

  render() {
    const { dealer, booking, car, kilo } = this.props.store
    //Render Model Label without BrandLetter first
    const carName = `${car.ModelLabel} - ${car.EnergyLabel}`
    return (
      <div className='carSummary-section carSummary-fullcontainer'>
        <DealerSummary
          name={dealer.name}
          isExistPrestationWithForfait={this.state.isExistPrestationWithForfait}
          adress={`${dealer.adress} \n ${dealer.zip} ${dealer.city} `}
        />
        <TimeSummary
          date={booking.date}
          isExistPrestationWithForfait={this.state.isExistPrestationWithForfait}
          time={booking.hour}
        />
        <CarSummary
          Name={car.ModelLabel && carName}
          Kilometrage={kilo.kilometrage}
          Vin={car.SerialNumber}
          isExistPrestationWithForfait={this.state.isExistPrestationWithForfait}
          Imat={car.Registration}
        />
      </div>
    )
  }
}
export default connect(mapStateToProps)(SummaryBlock)
